<template>
  <div class="validator common-calculator-content" ref="validatorCalc">
    <div class="common-calculator-title">Reward Calculator</div>
    <div class="common-calculator-subtitle">Validator's blockreward calculator</div>
    <div class="common-calculator-title-line"></div>
    <a-form
      :layout="'vertical'"
    >
      <a-form-item label="Total current token supply" :validate-status="total === '0' ? 'error' : ''" :help="total === '0' ? ERRORNOZERO : ''">
        <a-input size="large" v-model="cpTotal" placeholder="Please enter Total current token supply" />
      </a-form-item>
      <a-form-item label="Annual inflation rate" >
        <a-input size="large" v-model="cpInflation" suffix="%" placeholder="Please enter Annual inflation rate" />
      </a-form-item>
      <a-form-item label="Block time (sec)" :validate-status="blockTime === '0' ? 'error' : ''" :help="blockTime === '0' ? ERRORNOZERO : ''">
        <a-input size="large" v-model="cpBlockTime" suffix="sec" placeholder="Please enter Block time (sec)" />
      </a-form-item>
      <a-form-item label="Ecosystem & Community tax pool rate" >
        <a-input size="large" v-model="cpContribution" suffix="%" placeholder="Please enter Ecosystem & Community tax pool rate" />
      </a-form-item>
      <a-form-item label="Total staked(bonded) token ratio" >
        <a-input size="large" v-model="cpDelegateAccountedTotal" suffix="%" placeholder="Please enter Total staked(bonded) token ratio" />
      </a-form-item>
      <a-form-item label="Commission" >
        <a-input size="large" v-model="cpCommission" suffix="%" placeholder="Please enter Commission" />
      </a-form-item>
      <a-form-item label="Total number of staked token of the node" :validate-status="delegateAmount === '0' ? 'error' : ''" :help="delegateAmount === '0' ? ERRORNOZERO : ''">
        <a-input size="large" v-model="cpDelegateAmount" placeholder="Please enter Total number of staked token of the node" />
      </a-form-item>
      <a-form-item label="Validator's self-staked token" :validate-status="delegateAmountSelfState" :help="delegateAmountSelfHelp">
        <a-input size="large" v-model="cpDelegateAmountSelf" placeholder="Please enter Validator's self-staked token" />
      </a-form-item>
      <a-form-item label="Participation period (day)" :validate-status="rewardDate === '0' ? 'error' : ''" :help="rewardDate === '0' ? ERRORNOZERO : ''">
        <a-input size="large" v-model="cpRewardDate" suffix="day" placeholder="Please enter Participation period (day)" />
      </a-form-item>
    </a-form>
    <div class="common-calculator-row smallMode">
      <div class="common-calculator-row-item common-calculator-row-title">
        <div class="common-calculator-row-label">Total validator's blockreward</div>
      </div>
      <div class="common-calculator-row-item common-calculator-row-input">
        <div class="common-calculator-row-context">{{res}}</div>
      </div>
    </div>
    <div class="common-calculator-row smallMode">
      <div class="common-calculator-row-item common-calculator-row-title">
        <div class="common-calculator-row-label">Ecosystem & Community tax pool</div>
      </div>
      <div class="common-calculator-row-item common-calculator-row-input">
        <div class="common-calculator-row-context">{{reward}}</div>
      </div>
    </div>
    <!--<div class="common-calculator-line"></div>-->
    <!--<div class="common-calculator-note">{{'Annual increment of token ' + increase}}</div>-->
    <!--<div class="common-calculator-note">{{'Average blockreward ' + oneBlockReward}}</div>-->
    <!--<div class="common-calculator-note">{{'Annual contribution of ecosystem & community tax pool ' + oneYearCommunityReward}}</div>-->
    <!--<div class="common-calculator-note">{{'Total number of generated block within the participation period ' + howManyBlock}}</div>-->
    <!--<div class="common-calculator-line"></div>-->
    <!--<div class="common-calculator-info">*Formula of blockreward of Validator：[Total current token supply * annual inflation rate / (365.25 * 24 *3600/block time)] * (Participation period * 24* 3600/blocktime) * (1- Ecosystem & Community tax pool rate) * (Total number of staked token of the node / (Current token supply * total staked token ratio ))* (commission rate + (1-commission rate)* the number of self-staked token / total number of staked token of the node)</div>-->
    <!--<div class="common-calculator-info">*Formula of Ecosystem & Community tax pool: [ Total current token supply * annual inflation rate / (365.25 * 24 * 3600 /block time)] * (Participation period * 24 * 3600/ blocktime) * Ecosystem & Community tax pool rate</div>-->
    <!--<div class="common-calculator-info">*Formula of annual increment : Total current token supply * annual inflation rate</div>-->
    <!--<div class="common-calculator-info">*Formula of average blockreward: [Total current token supply * annual inflation rate / (365.25 * 24 *3600 /block time)]</div>-->
    <!--<div class="common-calculator-info">*Formula of Ecosystem & Community tax pool: Total current token supply * annual inflation rate  *Ecosystem & Community tax pool rate</div>-->
    <!--<div class="common-calculator-info">*Formula of total number of generated block within the period: Participation period * 24 *3600 / block time</div>-->
  </div>
</template>

<script>
  import BN from "bignumber.js"
  import {tool} from "../js/mixin";

  export default {
    name: 'Home',
    data () {
      return {
        total: '',                          // 当前发行总量
        inflation: '',                      // 年通货膨胀率
        blockTime: '',                      // 出块间隔
        contribution: '',                   // 用于生态和社区的比例
        delegateAccountedTotal: '',         // 所有委托总量占当前发行量比例
        commission: '',                     // 验证人收取佣金比例
        delegateAmount: '',                 // 验证人拥有的总委托金额
        delegateAmountSelf: '',             // 验证人拥有的自委托数量
        rewardDate: '',                     // 收益计算时长
        delegateAmountSelfState: '',        // 验证人拥有的自委托数量
        delegateAmountSelfHelp: '',         // 收益计算时长(日)
        ERRORNOZERO: 'Please enter non-zero numbers',
        ERRORNOBIGTHANTOTAL: 'Amount of self boned tokens must be less than that of your total bonded tokens',
      }
    },
    mixins: [tool],
    computed: {
      cpTotal: {
        get () {
          return this.total
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 18)
          this.total = null
          this.total = this.addThousandSeparator(myVal)
        }
      },
      cpInflation: {
        get () {
          return this.inflation
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 5)
          this.inflation = null
          this.inflation = this.addThousandSeparator(myVal)
        }
      },
      cpBlockTime: {
        get () {
          return this.blockTime
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 0)
          this.blockTime = null
          this.blockTime = this.addThousandSeparator(myVal)
        }
      },
      cpContribution: {
        get () {
          return this.contribution
        },
        set (val) {
          let myVal = this.onlyNumber(val, 5)
          myVal = this.smallTo(myVal, 100)
          this.contribution = null
          this.contribution = myVal
        }
      },
      cpDelegateAccountedTotal: {
        get () {
          return this.delegateAccountedTotal
        },
        set (val) {
          let myVal = this.onlyNumber(val, 5)
          myVal = this.smallTo(myVal, 100)
          this.delegateAccountedTotal = null
          this.delegateAccountedTotal = this.addThousandSeparator(myVal)
        }
      },
      cpCommission: {
        get () {
          return this.commission
        },
        set (val) {
          let myVal = this.onlyNumber(val, 5)
          myVal = this.smallTo(myVal, 100)
          this.commission = null
          this.commission = myVal
        }
      },
      cpDelegateAmount: {
        get () {
          return this.delegateAmount
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 18)
          if (new BN(this.clearThousandSeparator(this.delegateAmountSelf)).gt(new BN(myVal))) {
            // 如果自委托大于总委托  报错
            this.delegateAmountSelfState = 'error'
            this.delegateAmountSelfHelp = this.ERRORNOBIGTHANTOTAL
          } else {
            this.delegateAmountSelfState = ''
            this.delegateAmountSelfHelp = ''
          }
          this.delegateAmount = null
          this.delegateAmount = this.addThousandSeparator(myVal)
        }
      },
      cpDelegateAmountSelf: {
        get () {
          return this.delegateAmountSelf
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 18)

          if (myVal.toString() === '0') {
            this.delegateAmountSelfState = 'error'
            this.delegateAmountSelfHelp = this.ERRORNOZERO
          } else if (new BN(myVal).gt(new BN(this.clearThousandSeparator(this.delegateAmount)))) {
            // 如果自委托大于总委托  报错
            this.delegateAmountSelfState = 'error'
            this.delegateAmountSelfHelp = this.ERRORNOBIGTHANTOTAL
          } else {
            this.delegateAmountSelfState = ''
            this.delegateAmountSelfHelp = ''
          }
          this.delegateAmountSelf = null
          this.delegateAmountSelf = this.addThousandSeparator(myVal)
        }
      },
      cpRewardDate: {
        get () {
          return this.rewardDate
        },
        set (val) {
          let myVal = this.clearThousandSeparator(val)
          myVal = this.onlyNumber(myVal, 0)
          this.rewardDate = null
          this.rewardDate = this.addThousandSeparator(myVal)
        }
      },
      // n天总收益
      all () {
        // [发行总量 * 年通货膨胀率 / (365 * 24 *3600 / 出块间隔)] * (duration *24 * 3600 / 出块间隔）
        const res = new BN(this.clearThousandSeparator(this.total))
          .multipliedBy(new BN(this.clearThousandSeparator(this.inflation)).div(100))
          .div(new BN(365).multipliedBy(24 * 60 * 60).div(this.clearThousandSeparator(this.blockTime)))
          .multipliedBy(new BN(this.clearThousandSeparator(this.rewardDate)).multipliedBy(24 * 60 * 60))
          .div(this.clearThousandSeparator(this.blockTime))
        return res
      },
      // 验证人将收获的收益
      res () {
        // all *（1 - 用于生态和社区的比例）* (验证人拥有的总委托金额 / (当前发行总量 * 所有委托总量占当前发行量比例)) * (佣金 + （1-佣金）* 自委托数量 /验证人拥有的总委托金额)
        if (isNaN(this.all)) {
          return '--'
        }
        const delegateBN = new BN(this.clearThousandSeparator(this.delegateAmount))
        const commissionBN = new BN(this.clearThousandSeparator(this.commission)).div(100)
        const res = this.all
          .multipliedBy(new BN(1).minus(new BN(this.clearThousandSeparator(this.contribution)).div(100)))
          .multipliedBy(delegateBN)
          .div(new BN(this.clearThousandSeparator(this.total)).multipliedBy(new BN(this.delegateAccountedTotal).div(100)))
          .multipliedBy(commissionBN.plus(new BN(1).minus(commissionBN).multipliedBy(new BN(this.clearThousandSeparator(this.delegateAmountSelf))).div(delegateBN)))
        return this.addThousandSeparator(res.toFixed(5, 1))
      },
      // 生态和社区将获得的奖励
      reward () {
        // all * 用于生态和社区的比例
        if (isNaN(this.all)) {
          return '--'
        }
        const res = this.all.multipliedBy(new BN(this.clearThousandSeparator(this.contribution)).div(100))
        return this.addThousandSeparator(res.toFixed(5, 1))
      },
      // 一年将增发数
      increase () {
        //  发行总量 * 年通货膨胀率
        if (this.total === '' || this.inflation === '') {
          return '--'
        }
        const res = new BN(this.clearThousandSeparator(this.total))
          .multipliedBy(new BN(this.clearThousandSeparator(this.inflation)).div(100))
          .toFixed(5, 1)
        return this.addThousandSeparator(res)
      },
      // 平均一个块的奖励
      oneBlockReward () {
        // [发行总量 * 年通货膨胀率 / (365 * 24 *3600 / 出块间隔)]
        if (this.total === '' || this.inflation === '' || this.blockTime === '') {
          return '--'
        }
        const res = new BN(this.clearThousandSeparator(this.total))
          .multipliedBy(new BN(this.clearThousandSeparator(this.inflation)).div(100))
          .div(new BN(365).multipliedBy(24 * 60 * 60).div(this.clearThousandSeparator(this.blockTime)))
        return this.addThousandSeparator(res.toFixed(5, 1))
      },
      // 生态社区一年将获得数
      oneYearCommunityReward () {
        // 发行总量 * 年通货膨胀率 * 用于生态和社区的比例
        if (this.total === '' || this.inflation === '' || this.contribution === '') {
          return '--'
        }
        const res = new BN(this.clearThousandSeparator(this.total))
          .multipliedBy(new BN(this.clearThousandSeparator(this.inflation)).div(100))
          .multipliedBy(new BN(this.clearThousandSeparator(this.contribution)).div(100))
        return this.addThousandSeparator(res.toFixed(5, 1))
      },
      // 所选时间内会出块个数为
      howManyBlock () {
        // 收益计算时长 * 24 * 3600 / 出块间隔
        if (this.blockTime === '' || this.rewardDate === '') {
          return '--'
        }
        const res = new BN(this.clearThousandSeparator(this.rewardDate))
          .multipliedBy(new BN(24 * 60 * 60))
          .div(new BN(this.clearThousandSeparator(this.blockTime)))
        return this.addThousandSeparator(res.toFixed(0, 1))
      }
    },
    methods: {
    },
    mounted () {

    },
    beforeDestroy () {
    }
  }
</script>

<style scoped>

</style>
